"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmptyCanAnswerComponent = /** @class */ (function () {
    function EmptyCanAnswerComponent() {
        this.REPORT_CAN_START_CHECK_BUS = 213;
    }
    EmptyCanAnswerComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(EmptyCanAnswerComponent.prototype, "trnRsnIds", {
        get: function () {
            return this.trnRsnIds;
        },
        set: function (trnRsnIds) {
            this._trnRsnIds = trnRsnIds;
        },
        enumerable: true,
        configurable: true
    });
    EmptyCanAnswerComponent.prototype.hasReportCanStartCheckBusTrnRsn = function () {
        return this._trnRsnIds && this._trnRsnIds.includes(this.REPORT_CAN_START_CHECK_BUS);
    };
    EmptyCanAnswerComponent.ctorParameters = function () { return []; };
    return EmptyCanAnswerComponent;
}());
exports.EmptyCanAnswerComponent = EmptyCanAnswerComponent;
//# sourceMappingURL=empty-can-answer.component.js.map


// WEBPACK FOOTER //
// empty-can-answer.component.js